import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CredentialVerification } from './../../../../shared/models/products/credential-verification';
import { Exam } from './../../../../shared/models/products/exam';
import { OtherProduct } from './../../../../shared/models/products/other-product';
import { IProduct } from './../../../../shared/models/products/product';
import { Renewal } from './../../../../shared/models/products/renewal';
import { UserService } from './../../../../../shared/services/user.service';

enum ProductType {
  Credential,
  ExamProduct,
  OtherProductType,
  RenewalProduct
}

@Component({
  selector: 'app-product-row',
  templateUrl: './product-row.component.html',
  styleUrls: ['./product-row.component.css']
})
export class ProductRowComponent {
  @HostBinding('class') hostClass = 'cart-item';

  productTypes = ProductType;

  @Input() product: any;
  @Input() canRemove = true;
  @Output() remove = new EventEmitter<IProduct>();

  get productType() {
    if (!this.product || !this.product.constructor) {
      return null;
    }

    switch (this.product.constructor) {
      case CredentialVerification:
        return ProductType.Credential;
      case Exam:
        return ProductType.ExamProduct;
      case OtherProduct:
        return ProductType.OtherProductType;
      case Renewal:
        return ProductType.RenewalProduct;
      default:
        return null;
    }
  }

  constructor(private userService: UserService) {}

  isExpired(): boolean {
    return this.userService.CurrentUser.hasExpiredCredentials &&
      !this.userService.CurrentUser.credentialHolder;
  }

  get effectivePrice() {
    return this.product.price;
  }

  get basePrice() {
    return this.product.price;
  }

  onRemove() {
    this.remove.emit(this.product);
  }
}